(ns entities.core
  (:require
    [entities.assets.core]
    [entities.brand.core]
    [entities.estate.core]
    [entities.expenses.core]
    [entities.income.core]
    [entities.insurance.core]
    [entities.key-accomplishments.core]
    [entities.liabilities.core]
    [entities.partner.core]
    [entities.priorities.core]
    [entities.review.core]
    [entities.risk-profile.core]
    [entities.tax.core]
    [entities.specs :as sp]
    [cljs.spec.alpha :as s]
    [very.re-frame.core :as rf]
    ))

(defn- do-fx [dsl]
  (rf/>evt [
            (keyword (str (name (:type dsl)) "/" (name (:op dsl))))
            dsl
            ]))

(defn fx [dsl]
  (s/assert ::sp/spec dsl)
  (cond
    (sequential? dsl) (doseq [x dsl] (do-fx x))
    (map? dsl) (do-fx dsl)))
